/** TIMS logistics for one playback round trip -- GET /api/round-trips/playback/{id}/logistics
 *  (serving/round_trip_playback.py `_logistics`), read from the stored TIMS register. */

export interface LrStage {
  event_code: string
  label: string
  event_ts: number | null
  /** When it was keyed into TIMS. */
  recorded_ts: number | null
  /** recorded_ts - event_ts, minutes. Over 15 = keyed in late. */
  lag_min: number | null
  site_name: string | null
  odo_km: number | null
  soc_pct: number | null
  tonnage: number | null
  driver_name: string | null
  driver_id: string | null
  tp_driver_id: string | null
  entry_source: string | null
}

export interface TripLr {
  lr_number: string
  di_numbers: string[]
  first_ts: number | null
  last_ts: number | null
  tonnage: number | null
  distance_km: number | null
  max_lag_min: number | null
  driver_name: string | null
  tp_driver_id: string | null
  stages: LrStage[]
}

export interface TripLogistics {
  cycle_id: string
  vehicle_id: string
  window: { from: number; to: number }
  driver: { driver_name: string; tp_driver_id: string | null } | null
  driver_changes: string[]
  lrs: TripLr[]
}

/** A gate scan keyed more than this many minutes after it happened is flagged. */
export const LATE_KEYING_MIN = 15
